import ICONS from './ICONS';

import IEXPLORE from './IEXPLORE.js';
import CDSAMPLE from './CDSAMPLE';
import SHUTDOWN from './SHUTDOWN';
import EXPLORER from './EXPLORE/EXPLORER';
import moment from 'moment';
import NOTEPAD from './NOTEPAD';
import TRUISMS from './TRUISMS.js';

let defaultDirectoryIcon_16 = ICONS.DIR_OPEN;
let defaultDirectoryIcon_32 = ICONS.DIR_CLOSED_32;
let defaultFileIcon_16 = ICONS.WINFILE_32;
let defaultFileIcon_32 = ICONS.WINFILE_32;

function Directory(children, icon16, icon32, displayName) {
    let node = {
        type: "directory",
        children: children || [],
        icon16: icon16 || defaultDirectoryIcon_16,
        icon32: icon32 || defaultDirectoryIcon_32,
        displayName: displayName
    };

    return node;
}

function File(contents, icon16, icon32) {
    return {
        type: "file",
        icon16: icon16 || defaultFileIcon_16,
        icon32: icon32 || defaultFileIcon_32,
        contents: contents
    };
}

function Link(destination, isSoft) {
    return {
        type: "link",
        destination: destination,
        isSoft: isSoft
    };
}

function exe(wndClass) { 
    return (lpCommandLine) => {
        window.WINAPI.CreateWindow(wndClass, { commandLine: lpCommandLine });
    };
}

// Scandisk.log
let time = moment(new Date()).format('h:mmA');
let date = moment(new Date()).format('dddd, MMMM DD, YYYY');
let scandiskLog = "Microsoft ScanDisk\n\n\nLog file generated at " + time + " on " + date + "." +
    "\n\nScanDisk checked drive C for problems, with the following results:\n\nDirectory structure" + 
    "\n\n\tScanDisk did not find any problems.\n\nFile allocation table\n\n\tScanDisk did not find any problems." +
    "\n\nFile system\n\n\tScanDisk did not find any problems.\n\nSurface scan\n\n\tScanDisk did not perform any tests.\n";

// Thanks.txt
let thanks = "ATTRIBUTIONS\n------------\n\nBIOS font from https://int10h.org/oldschool-pc-fonts/\nLicence: https://creativecommons.org/licenses/by-sa/4.0/\n\n" +
    "MSSansSerif converted using https://github.com/kreativekorp/bitsnpicas\n\n" +
    "Fixedsys font from https://github.com/kika/fixedsys/releases"

// the main C: drive
var CDRIVE = Directory({
    "WINDOWS": Directory({
        "DESKTOP": Directory({
            "My Computer": Link(""),
            "Recycle Bin": Link("C:\\RECYCLED"),
            "The Internet": Link("C:\\WINDOWS\\iexplore.exe"),
            "Truisms": Link("C:\\WINDOWS\\Truisms.exe", true),
            "Cdsample": Link("C:\\WINDOWS\\Cdsample.exe", true),
        }),
        "Start Menu": Directory({
            "Programs": Directory({
                "Windows Explorer": Link("C:\\WINDOWS\\Explorer.exe", true),
                "Internet Explorer": Link("C:\\WINDOWS\\iexplore.exe", true),
                "Truisms": Link("C:\\WINDOWS\\Truisms.exe", true),
                "Accessories": Directory({
                    "Notepad": Link("C:\\WINDOWS\\Notepad.exe", true),
                    "Interactive CD Sampler": Link("C:\\WINDOWS\\Cdsample.exe", true),
                }),
                "StartUp": Directory({
                    "Iexplore": Link("C:\\WINDOWS\\iexplore.exe", true),
                })
            }),
            "Documents": Directory({
                "Thanks.txt": Link("C:\\WINDOWS\\Thanks.txt", true)
            })
        }),
        "iexplore.exe": File(exe(IEXPLORE), ICONS.IEXPLORE_16, ICONS.IEXPLORE_32),
        "Cdsample.exe": File(exe(CDSAMPLE), ICONS.CDSAMPLE_16, ICONS.CDSAMPLE_32),
        "Explorer.exe": File(exe(EXPLORER), ICONS.EXPLORER_16, ICONS.MY_PC_32),
        "Shutdown.exe": File(() => window.WINAPI.InitiateSystemShutdown(), ICONS.EXEC_16, ICONS.EXEC_32), //File(exe(SHUTDOWN)),
        "Notepad.exe": File(exe(NOTEPAD), ICONS.NOTEPAD_16, ICONS.NOTEPAD_32),
        "Truisms.exe": File(TRUISMS.exe, ICONS.EXEC_16, ICONS.EXEC_32),
        "Thanks.txt": File(thanks, ICONS.TEXTFILE_16, ICONS.TEXTFILE_32)
    }),
    "RECYCLED": Directory({}, ICONS.RECYCLED_16, ICONS.RECYCLED_32, "Recycle Bin"),
    "Scandisk.log": File(scandiskLog, ICONS.TEXTFILE_16, ICONS.TEXTFILE_32)
}, ICONS.CDRIVE_16, ICONS.CDRIVE_32, "(C:)");

// "My Computer"
let FAT32 = Directory({
    "A:": Directory({}, ICONS.ADRIVE_16, ICONS.ADRIVE_32, "3½ Floppy (A:)"),
    "C:": CDRIVE
}, ICONS.MY_PC_16, ICONS.MY_PC_32, "My Computer");

export default FAT32;



// WEBPACK FOOTER //
// ./src/walleris/FAT32.js